












import { Component, Vue } from "vue-property-decorator";
import { HeaderCpt, SidebarCpt } from "./components";

@Component({
  components: {
    SidebarCpt,
    HeaderCpt,
  },
})
export default class Default extends Vue {
}
